import { render, staticRenderFns } from "./FieldMapper.vue?vue&type=template&id=6caaaf56&scoped=true"
import script from "./FieldMapper.vue?vue&type=script&lang=js"
export * from "./FieldMapper.vue?vue&type=script&lang=js"
import style0 from "./FieldMapper.vue?vue&type=style&index=0&id=6caaaf56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6caaaf56",
  null
  
)

export default component.exports